<template>
  <div>
    <div class="form-group">
      <label>Activer la collecte</label>
      <select v-model="localConfig.enabled">
        <option :value="true">Oui</option>
        <option :value="false">Non</option>
      </select>
    </div>

    <div class="form-group">
      <label>Champs à collecter</label>
      <div v-for="(field, index) in localConfig.fields" :key="index" class="faq-pair">
        <input v-model="localConfig.fields[index]" placeholder="Nom du champ" />
        <button type="button" @click="removeField(index)">Supprimer</button>
      </div>
      <button type="button" @click="addField">Ajouter un champ</button>
    </div>

    <div class="modal-actions">
      <button type="button" @click="save">Sauvegarder</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollecteConfig',
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  emits: ['update'],
  data() {
    return {
      localConfig: {
        enabled: true,
        fields: []
      }
    }
  },
  watch: {
    config: {
      immediate: true,
      handler(newVal) {
        this.localConfig = {
          enabled: newVal?.enabled ?? true,
          fields: Array.isArray(newVal?.fields) ? [...newVal.fields] : ['email']
        }
      }
    }
  },
  methods: {
    addField() {
      this.localConfig.fields.push('')
    },
    removeField(index) {
      this.localConfig.fields.splice(index, 1)
    },
    save() {
      this.$emit('update', this.localConfig)
    }
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 20px;
}

.faq-pair {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.faq-pair input {
  flex: 1;
}

button {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  background-color: #4f46e5;
  color: white;
  cursor: pointer;
}

button:hover {
  background-color: #4338ca;
}

.modal-actions {
  margin-top: 20px;
  display: flex;
  gap: 10px;
}
</style>
